import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import '../NewsListing.scss';
import { FaArrowRight } from 'react-icons/fa';
import Pagetitlesection from '../components/pagetitlesection';
import homebanner from "../assets/home-banner.png";

const NewsListing = () => {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [articlesPerPage] = useState(6); // Show 6 articles per page
  const newsSectionRef = useRef(null);

  useEffect(() => {
    fetchArticles();
  }, []);

  const fetchArticles = async () => {
    try {
      const response = await fetch('/php-api/getarticlelisting.php');
      const data = await response.json();
      
      if (data.success) {
        setArticles(data.articles);
      } else {
        setError('Articles not found');
      }
      setLoading(false);
    } catch (err) {
      setError('Failed to load articles');
      setLoading(false);
    }
  };

  // Get current articles for pagination
  const indexOfLastArticle = currentPage * articlesPerPage;
  const indexOfFirstArticle = indexOfLastArticle - articlesPerPage;
  const currentArticles = articles.slice(indexOfFirstArticle, indexOfLastArticle);
  const totalPages = Math.ceil(articles.length / articlesPerPage);

  // Change page
  // const paginate = (pageNumber) => setCurrentPage(pageNumber); 
const paginate = (pageNumber) => {
  setCurrentPage(pageNumber);

  newsSectionRef.current?.scrollIntoView({
    behavior: "smooth",
    block: "start",
  });
};
  if (loading) return <div className="loading">Loading articles...</div>;
  if (error) return <div className="error">{error}</div>;

  return (
    <>
      <Header />
      <div className="page-body-container">
          <Pagetitlesection title="Latest News" backgroundImage={homebanner} />
        <div className="news-listing-container" ref={newsSectionRef}>
          
          <div className="news-grid">
            {currentArticles.length > 0 ? (
              currentArticles.map((article) => (
                <div key={article.id} className="news-card">
                  {article.image_url && (
                    <div className="news-card-image">
                      <img src={article.image_url} alt={article.title} />
                    </div>
                  )}
                  
                  <div className="news-card-content">
                    <h2 className="news-card-title">{article.title}</h2>
                    
                    <div className="news-card-meta">
                      {/* <span className="publish-date">{article.publishDate}</span> */}
                      <span className="publish-date">
  {new Date(article.publishDate).toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  })}
</span>
                      <span className="category">{article.category}</span>
                    </div>
                    
                    <div 
                      className="news-card-excerpt"
                      dangerouslySetInnerHTML={{ __html: 
                        article.excerpt || article.content.substring(0, 150) + '...' 
                      }}
                    />
                    
                    <Link 
                      to={`/news/${article.slug}`} 
                      className="read-more-btn"
                    >
                      Read More <FaArrowRight />
                    </Link>
                  </div>
                </div>
              ))
            ) : (
              <div className="no-articles">No articles found.</div>
            )}
          </div>
          
          
          {/* Pagination */}
{totalPages > 1 && (
  <>
  <div className="pagination pagination-list"> 
    {/* Previous */}
    <button
      onClick={() => paginate(currentPage - 1)}
      disabled={currentPage === 1}
      className="pagination-btn"
    >
      Previous
    </button>

    {/* First Page */}
    {currentPage > 3 && (
      <>
        <button
          onClick={() => paginate(1)}
          className="pagination-btn"
        >
          1
        </button>

        {currentPage > 4 && (
          <span className="pagination-dots">...</span>
        )}
      </>
    )}

    {/* Dynamic Page Numbers */}
    {Array.from({ length: totalPages }, (_, i) => i + 1)
      .filter(
        (number) =>
          number >= currentPage - 2 &&
          number <= currentPage + 2
      )
      .map((number) => (
        <button
          key={number}
          onClick={() => paginate(number)}
          className={`pagination-btn ${
            currentPage === number ? "active" : ""
          }`}
        >
          {number}
        </button>
      ))}

    {/* Last Page */}
    {currentPage < totalPages - 2 && (
      <>
        {currentPage < totalPages - 3 && (
          <span className="pagination-dots">...</span>
        )}

        <button
          onClick={() => paginate(totalPages)}
          className="pagination-btn"
        >
          {totalPages}
        </button>
      </>
    )}

    {/* Next */}
    <button
      onClick={() => paginate(currentPage + 1)}
      disabled={currentPage === totalPages}
      className="pagination-btn"
    >
      Next
    </button>
   

   
  </div>
   {/* Mobile view Pagination Start */}
   <div className="goto-page">
  <span>Go to</span>

  <select
    value={currentPage}
    onChange={(e) => paginate(Number(e.target.value))}
    className="page-dropdown"
  >
    {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
      <option key={page} value={page}>
        {page}
      </option>
    ))}
  </select>

  <span>of {totalPages}</span>
</div>
{/* Mobile view Pagination end */}
</>
)}
        </div>
        <Footer />
      </div>
    </>
  );
};

export default NewsListing;